/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dataset-search-input[_ngcontent-%COMP%]{cursor:pointer;font-weight:500;color:#212121!important}"];
export { styles as styles };
